import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AppService } from 'app/app.service';
import { canUseFeature } from 'app/guards/features.guard';
import { NavigationService } from 'app/services';
import { filter, first, map } from 'rxjs';

export const assetStateGuard: CanActivateFn = () => {
    const appService = inject(AppService);
    const navigation = inject(NavigationService);

    return appService.client$.pipe(
        filter(client => !!client),
        first(),
        map(() => canUseFeature(appService.features.page.assetstate?.enabled, appService.user, navigation.getDefaultUrlTree()))
    );
}
